//@flow

type ActionType = "FixedResolution/SET_SCALE"

type FixedResolutionAction = {
  type: ActionType,
  payload: {
    currentScaleFactor: number,
    x: number,
    y: number
  }
}

type FixedResolutionState = {
  +currentScaleFactor: number,
  +x: number,
  +y: number
}

export type SetScale = (
  currentScaleFactor: number,
  x: number,
  y: number
) => FixedResolutionAction

export const setScaleAndOffsets: SetScale = (
  currentScaleFactor: number,
  x: number,
  y: number
): FixedResolutionAction => {
  return {
    type: "FixedResolution/SET_SCALE",
    payload: { currentScaleFactor, x, y }
  }
}

export const currentScaleFactor = (state: {
  fixedResolution: FixedResolutionState
}): number => state.fixedResolution.currentScaleFactor

type Coordinate = { x: number, y: number }

export type CoordinateConversion = (coord: Coordinate) => Coordinate

export const getContainerCoordinate = (state: {
  fixedResolution: FixedResolutionState
}) => (coord: Coordinate): Coordinate => ({
  x:
    (coord.x - state.fixedResolution.x / 2) /
    state.fixedResolution.currentScaleFactor,
  y:
    (coord.y - state.fixedResolution.y / 2) /
    state.fixedResolution.currentScaleFactor
})

export const reducer = (
  state: FixedResolutionState,
  action: FixedResolutionAction
): FixedResolutionState => {
  switch (action.type) {
    case "FixedResolution/SET_SCALE":
      return {
        ...state,
        currentScaleFactor: action.payload.currentScaleFactor || 1,
        x: action.payload.x || 0,
        y: action.payload.y || 0
      }
    default:
      return state || { currentScaleFactor: 1, x: 0, y: 0 }
  }
}



// WEBPACK FOOTER //
// ./src/Kiosk/FixedResolutionContainer/redux.js